"use client";

import Image from "@/components/Image";
import { useEffect, useState } from "react";
import styles from "./HomeXy.module.css";
// import { DeviceType } from "@/app/utils";

// import device from "current-device";

const HomeXy = () => {
  const images = ["/pic2_xy_01.png", "/pic1_xy_01.png"];
  const [deviceType, setDeviceType] = useState<string>("other");
  const [imgIndex, setImgIndex] = useState(0);
  // 在组件挂载时获取设备类型
  useEffect(() => {
    import("current-device").then((module) => {
      const deviceType = module.default.type;
      setDeviceType(deviceType);
      if (deviceType === "desktop") {
        setDeviceType("pc");
      }
      if (deviceType === "unknown") {
        setDeviceType("other");
      }
    });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setImgIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(timer);
  });

  return (
    <section
      id="home-section"
      className="flex justify-center items-center w-full bg-[#212121] px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] mx-auto overflow-hidden relative"
    >
      {/* 背景部分 */}
      <div className="absolute inset-0 max-w-[1920px] w-full h-full min-h-[510px] bg-[#212121] mx-auto flex justify-between">
        <Image
          src="/bg_xy_01.png"
          alt="Banner Background"
          width={1920}
          height={510}
          className="object-cover w-full h-full"
          style={{ objectPosition: "center" }}
        />
      </div>

      {/* 内容部分 */}
      <div className="relative w-full max-w-[1360px] min-h-[510px] mx-auto flex flex-row [@media(max-width:1080px)]:flex-col [@media(max-width:1080px)]:pt-[80px] [@media(max-width:1080px)]:items-center justify-between [@media(max-width:1080px)]:gap-[38px]">
        {/* 左边内容区域 */}
        <div className="flex flex-col w-full max-w-[644px] min-h-[348px] gap-[40px] justify-center">
          {/* 上面部分 - 图片和文字 */}
          <div className="flex flex-col w-full max-w-[644px] gap-[10px]">
            {/* 文字内容1 */}

            <Image
              src="/pic3_xy_01.png"
              alt="蜜蜂家校管理平台"
              width={426}
              height={74}
              className="h-[74px] object-contain"
            />

            {/* 文字内容2 */}
            <p className="w-full font-[PingFang SC] font-normal text-[14px] leading-[24px] tracking-[2px] text-[#666666]">
              蜜蜂智阅一体机聚焦作业场景，以 AI
              智能批改学生手写作业为核心软件能力，支持打印作业批改留痕的硬件能力，让教师轻松拥抱技术变革。其搭载强大处理系统，可快速完成全班作业扫描打印，短时间内实现全校作业并发批改，无需学生终端即可智能采集学情数据，更无需教师手动操作，系统自动生成全校作业学情分析报告，助力教师精准把握大单元学情。同时，一体机能对纸质资源进行智能改造，让旧资源在技术变革期也能发挥作用，为教育数字化转型提供强有力支持。
              有这强有力支持，蜜蜂家校依托 OCR
              技术、自有算法，更以多操作终端适配全场景教学需求，推动学校教学质量提升与数字化转型。
            </p>
          </div>

          {/* 下面部分 - 两个按钮 [@media(max-width:660px)]:flex-col */}
          <div className="flex flex-row w-auto h-[56px] gap-[24px]  mx-0 [@media(max-width:430px)]:gap-[4px]">
            {/* 第一个按钮 - 绿色 */}
            <a
              href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcnPtXd6gal9wBuRiBUpjLrKb?prefill_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=%E5%AE%98%E7%BD%91&hide_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=1"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-[174px] h-[56px] rounded-[30px] py-[14px] [@media(max-width:430px)]:px-[15px] px-[30px] bg-[#1DBA55] text-white text-[18px] font-medium"
              onClick={() => {
                window.Log.action(
                  "school_click",
                  {
                    from_part: "页头banner",
                    user_access_port: deviceType,
                  },
                  "HWOfficialPaidSchoolVersionPage",
                );
              }}
            >
              校方采购咨询
            </a>

            {/* 第二个按钮 - 白色 */}
            <a
              href="https://xy.mifengjiaoyu.com/login"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-[155px] h-[56px] rounded-[30px] py-[14px] [@media(max-width:430px)]:px-[15px] px-[30px] bg-white text-[#1DBA55] text-[18px] font-medium"
              onClick={() => {
                window.Log.action(
                  "banner_button_click_visit",
                  {
                    user_access_port: deviceType,
                  },
                  "HWOfficialPaidSchoolVersionPage",
                );
              }}
            >
              访问校园版
            </a>
          </div>
        </div>

        {/* 右边内容区域 - 在小屏幕上隐藏 */}
        <div
          className="flex justify-end overflow-hidden max-w-[540px] min-w-[540px] h-[510px] mr-0 self-end [@media(max-width:1080px)]:self-center [@media(max-width:580px)]:w-[93vw] [@media(max-width:580px)]:h-[87vw]"
          // 添加 h-full 和 self-end
        >
          <Image
            src={images[imgIndex]}
            alt="Product Showcase"
            width={540}
            height={imgIndex === 1 ? 730 : 510}
            className={`flex [@media(max-width:580px)]:hidden object-cover w-[540px] [@media(max-width:580px)]:w-[93vw] h-auto ${
              imgIndex === 1 ? styles["scroll-effect"] : ""
            }`}
            style={{
              height: imgIndex === 1 ? "730px" : "510px",
            }}
          />

          <Image
            src={images[imgIndex]}
            alt="Product Showcase"
            width={540}
            height={imgIndex === 1 ? 730 : 510}
            className={`hidden [@media(max-width:580px)]:flex mx-auto object-contain w-[90vw] h-auto ${
              imgIndex === 1 ? styles["scroll-effect1"] : ""
            }`}
            style={{
              height: imgIndex === 1 ? "126vw" : "88vw",
            }}
          />
          {/* <Image
            src="/pic2_xy_01.png"
            alt="Product Showcase"
            width={540}
            height={510}
            className="hidden [@media(max-width:1080px)]:flex object-cover w-[540px] h-auto"
          /> */}
        </div>
      </div>
    </section>
  );
};

export default HomeXy;
